import { render, staticRenderFns } from "./PropostasCdc.vue?vue&type=template&id=13e95fc2&scoped=true"
import script from "./PropostasCdc.vue?vue&type=script&lang=js"
export * from "./PropostasCdc.vue?vue&type=script&lang=js"
import style0 from "./PropostasCdc.vue?vue&type=style&index=0&id=13e95fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e95fc2",
  null
  
)

export default component.exports